import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Dashboard";
import MonCompte from "../pages/MonCompte/MonCompte";
import MonMagasin from "../pages/MonMagasin/MonMagasin";
import MesOffres from "../pages/MesOffres/MesOffres";
import Settings from "../pages/Settings/Settings";
import CGU from "../pages/Settings/CGU";
import PrivateRoute from "./PrivateRoutes";
import ScrollToTop from "../global/Common/ScrollToTop";
import { BrandProvider } from "../context/BrandContext";
import { CompanyConfigProvider } from "../context/CompanyConfigContext";
import { CompanyThemeProvider } from "../context/CompanyThemeContext";

const AppRouter = (): React.ReactElement => {
  return (
    <BrandProvider>
      <CompanyConfigProvider env="production">
        <CompanyThemeProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              {/* Ancienne page de connexion : les favoris et redirections Keycloak existants arrivent ici */}
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />

              <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/mon-compte" element={<MonCompte />} />
                <Route path="/mon-magasin" element={<MonMagasin />} />
                <Route path="/mes-offres" element={<MesOffres />} />
                <Route path="/parametres" element={<Settings />} />
                <Route path="/cgu" element={<CGU />} />
              </Route>

              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </CompanyThemeProvider>
      </CompanyConfigProvider>
    </BrandProvider>
  );
};

export default AppRouter;